var e=(e="",t=50)=>t&&e.length>t?e.slice(0,t)+"…":e;export{e as limitText};
//# sourceMappingURL=limitText.js.map